import { useEffect, useRef } from 'react'
import { Provider } from 'react-redux'
// import DotRing from './Components/DotRing/DotRing'
import { FullLoader } from './Components/LoaderBox/Loader'
import store from './store/store'

const TopLoaderBox = FullLoader(() => import('./Components/LoaderBox/TopLoaderBox'))
const Routes = FullLoader(() => import('./Routes'))

export const loaderRef = { barRef: null }

export default function App() {
  const myRef = useRef(null)
  // const { cursorChangeHandler } = useContext(MouseContext)
  useEffect(() => {
    loaderRef.barRef = myRef
  }, [])

  return (
    <Provider store={store}>
      <TopLoaderBox ref={myRef} />
      {/* <DotRing
        onMouseEnter={() => cursorChangeHandler('hovered')}
        onMouseLeave={() => cursorChangeHandler('')}
      /> */}
      <Routes />
    </Provider>
  )
}
